import { FC, useContext, useRef, useState} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../../../ag-grid.css'
import '../../../../../ag-theme-alpine.css'
import { warning } from "../../../../../utils/notifications"
import { EditTransporteModalDialog } from "./EditTransporteModalDialog/EditTransporteModalDialog"
import { euroRenderer, percentRenderer } from "../../../../../utils/helperFunctions"
import { UserContext } from "../../../../../Redux/UserContext"

export const TransporteTableSimple:FC<any> = (props) => {

    const gridRef :any= useRef();

    const { data, setData, dataMASTER, simulated, original, saveLoading, scenarioBase } = props
    
    const [state] = useContext(UserContext)

    const [ visible, setVisible ] = useState<boolean>(false)

    const [ selectedCell, setSelectedCell ] = useState<any>()

    const [ selectedRow, setSelectedRow ] = useState<any>()

    const [ mode, setMode] = useState<string>("")

    const [ type, setType ] = useState<string>("PKM")

    const handleClose = () => {
        setSelectedCell(undefined)
        setSelectedRow(undefined)
        setVisible(false)
        setMode("")
    }


    const handleEditCellContentPKM = (params:any) => {
        let { colId } = params.column
        if(colId !== 'km') {
            setType("PKM")
            let modo = colId.split("_")
            modo.slice(-1)[0] === 'a'? setMode("base") : setMode("comparision")
            if(modo.slice(-1)[0] === 'a') {
                if(simulated.scenario_base && !original.scenario_base) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_base && colId !== 'inflacion_esperada_a') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_base) {
                    warning("No se puede editar el escenario original.")
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            } else {
                if(simulated.scenario_comparision && !original.scenario_comparision) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.comparision && colId !== 'inflacion_esperada_b') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_comparision) {
                    warning("No se puede editar el escenario original.")
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            }
        }
        
        
    }

    const handleEditCellContentIE = (params:any) => {
        let { colId } = params.column
       
        if(colId !== 'mes' && colId !== 'anio') {
            setType("IE")
            let modo = colId.split("_")
            modo.slice(-1)[0] === 'a'? setMode("base") : setMode("comparision")
            if(modo.slice(-1)[0] === 'a') {
                if(simulated.scenario_base && !original.scenario_base) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_base && colId !== 'inflacion_esperada_a') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_base) {
                    warning("No se puede editar el escenario original.")
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            } else {
                if(simulated.scenario_comparision && !original.scenario_comparision) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.comparision && colId !== 'inflacion_esperada_b') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_comparision) {
                    warning("No se puede editar el escenario original.")
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            }
        }
        
        
    }

    const handleCellStylePKMEditable = (params:any) => {
        let original = dataMASTER.precio_km_table.find((ori:any) => ori.km === params.data.km)?.[params.column.colId]
        if(original !== params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',height:'100%',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',borderRight:'1px solid #dee2e6'}
        }   
    }

    const handleCellStyleIEEditable = (params:any) => {
        let original = dataMASTER.inflacion_esperada_table.find((ori:any) => `${ori.anio}${ori.mes}` === `${params.data.anio}${params.data.mes}`)?.[params.column.colId]
        if(original !== params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',height:'100%',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',borderRight:'1px solid #dee2e6'}
        }   
    }

    const handleCellStylePKM = (params:any) => {
        let original = dataMASTER.precio_km_table.find((ori:any) => ori.km === params.data.km)?.[params.column.colId]
       
        if(original !== params.value) {
            
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'rgb(236, 236, 236)',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6'}
        } 
    }

    const handleCellStyleIE = (params:any) => {
        let original = dataMASTER.inflacion_esperada_table.find((ori:any) => `${ori.anio}${ori.mes}` === `${params.data.anio}${params.data.mes}`)?.[params.column.colId]
       
        if(original !== params.value) {
            
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'rgb(236, 236, 236)',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6'}
        } 
    }

    
    
    return (
        <div className="transportetable__wrapper">
            <EditTransporteModalDialog
                    visible={visible}
                    setVisible={setVisible}
                    handleClose={handleClose}
                    selectedCell={selectedCell}
                    setSelectedCell={setSelectedCell}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    mode={mode}
                    setMode={setMode}
                    data={data}
                    dataMASTER={dataMASTER}
                    setData={setData}
                    type={type}   
                />
            <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'100%', width: '49.5%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'100%', width: '49.5%' }}>
            {
                    saveLoading?
                        <div className="scenario__overlay-table"></div>
                        :
                        false
                }
                <AgGridReact
                    ref={gridRef}
                    headerHeight={30}
                    getRowHeight={() => 30}
                    onCellDoubleClicked={state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) ? () => warning("No tienes permisos para realizar esta acción") : handleEditCellContentPKM : () => warning("No tienes permisos para realizar esta acción")}
                    rowData={data?.precio_km_table}
                    enableCellTextSelection
                    >
                    <AgGridColumn sortable cellStyle={handleCellStylePKM} headerClass={"header-resize"}   suppressNavigable={true} flex={1}   headerName={"KM"} field={"km"}></AgGridColumn>

                    <AgGridColumn cellStyle={handleCellStylePKMEditable} headerClass={"header-resize"} sortable cellRenderer={euroRenderer}    flex={1} suppressNavigable  headerName="Precio" field="precio_km_a"></AgGridColumn>
                    
    
                </AgGridReact>
            </div>
            <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'100%', width: '49.5%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'100%', width: '49.5%' }}>
            {
                    saveLoading?
                        <div className="scenario__overlay-table"></div>
                        :
                        false
                }
                <AgGridReact
                    ref={gridRef}
                    headerHeight={30}
                    getRowHeight={() => 30}
                    onCellDoubleClicked={state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) ? () => warning("No tienes permisos para realizar esta acción") : handleEditCellContentIE : () => warning("No tienes permisos para realizar esta acción")}
                    rowData={data?.inflacion_esperada_table}
                    enableCellTextSelection
                    >
                    <AgGridColumn sortable cellStyle={handleCellStyleIE} headerClass={"header-resize"}   suppressNavigable={true} flex={1}   headerName={"Mes"} field={"mes"}></AgGridColumn>
                    <AgGridColumn sortable cellStyle={handleCellStyleIE} headerClass={"header-resize"}  suppressNavigable={true} flex={1} headerName="Año"     field={"anio"}></AgGridColumn>
                    <AgGridColumn sortable   suppressNavigable={true} flex={1} hide   field={"id_tarifa"}></AgGridColumn>
                    <AgGridColumn cellStyle={handleCellStyleIEEditable} headerClass={"header-resize"} sortable  cellRenderer={percentRenderer}   flex={1} suppressNavigable  headerName="Inflación esperada" field="inflacion_esperada_a"></AgGridColumn>
                    
    
                </AgGridReact>
                
            </div>
        </div>
        
    )
}